import React, { useState, useEffect } from "react";
import CustomBox from "../../CustomComponents/CustomBox/CustomBox";
import CustomPaper from "../../CustomComponents/CustomPaper/CustomPaper";
import CustomCard from "../../CustomComponents/CustomCard/CustomCard";
import CustomTypography from "../../CustomComponents/CustomTypography/CustomTypography";
import CustomCardContent from "../../CustomComponents/CustomCardContent/CustomCardContent";
import { useStyles } from "../../../assets/jss/ContentDetails";

export default function TextComponentPreview(props:any) {
  const classes = useStyles();
  const [content, setContent] = useState(null);
  
  useEffect(() => {
    if (props.content) {
      setContent(props.content);
    }
  }, [props.content]);

  return (
    <>
      <CustomPaper elevation={0}>
        <CustomCard elevation={0} className={classes.cardContentWrapper}>
          <CustomCardContent className={classes.cardContent}>
            {content && (
              <>
                <CustomBox className={classes.cardContentBody}>
                  {content.title && (
                    <CustomTypography
                      component="h3"
                      variant="h3"
                      className={classes.headerTitle}
                    >
                      {content.title}
                    </CustomTypography>
                  )}
                  {content.content && (
                    <CustomBox
                      className={classes.contentDesc}
                      dangerouslySetInnerHTML={{ __html: content.content }}
                    />
                  )}
                </CustomBox>
              </>
            )}
          </CustomCardContent>
        </CustomCard>
      </CustomPaper>
    </>
  );
}
